import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core'
import { Subject } from 'rxjs'
import { fadeIn } from '../../../animations/fadeIn'
import { KeyingBookService } from '../../../services/keying.book.service'
import { KeyingDataSetsService } from '../../../services/keying.data.sets.service'
import { LoggingService } from '../../../services/logging.service'

@Component({
    selector: 'app-matrix-top-bar',
    templateUrl: './matrix-top-bar.component.html',
    styleUrls: ['./matrix-top-bar.component.scss'],
    animations: [fadeIn],
    standalone: false
})
export class MatrixTopBarComponent implements OnInit, OnDestroy {
  destroy$ = new Subject()

  @Input() mkSideBar
  @Input() selectedBook
  @Input() selectedCylinder
  @Input() selectedTab
  @Input() selectedMasterKey

  @Output() action = new EventEmitter<any>()

  constructor(
    public keyingDataSetsService: KeyingDataSetsService,
    public keyingBookService: KeyingBookService,
    private loggingService: LoggingService
  ) {}

  ngOnInit(): void {
    this.loggingService.log('mkSideBar:', this.mkSideBar)
  }

  ngOnDestroy() {
    this.destroy$.next(true)
    this.destroy$.complete()
  }

  saveMatrix() {
    this.action.emit('saveMatrix')
  }
}
